export default __webpack_public_path__ + "static/media/logoS01.235f87ca.jpg";